import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CurveType } from '../enums';
import { Curve } from '../models';

export interface DiagramState {
    diagramData?: Curve[] | null;
    disabledCurveTypes: CurveType[];
    chartIndex: number;
    isAbsoluteScaling: boolean;
}

const initialState: DiagramState = {
    disabledCurveTypes: [],
    chartIndex: 0,
    isAbsoluteScaling: true
};

export const diagramSlice = createSlice({
    name: 'diagram',
    initialState,
    reducers: {
        setDiagramData: (state: DiagramState, action: PayloadAction<Curve[] | null>) => {
            state.diagramData = action.payload;
        },
        setChartIndex: (state: DiagramState, action: PayloadAction<number>) => {
            state.chartIndex = action.payload;
        },
        setIsAbsoluteScaling: (state: DiagramState, action: PayloadAction<boolean>) => {
            state.isAbsoluteScaling = action.payload;
        },
        setDisabledCurveTypes: (state: DiagramState, action: PayloadAction<CurveType[]>) => {
            state.disabledCurveTypes = action.payload;
        }
    }
});

export const {
    setDiagramData,
    setDisabledCurveTypes,
    setChartIndex,
    setIsAbsoluteScaling
} = diagramSlice.actions;
export const diagramReducer = diagramSlice.reducer;
